import React, { useEffect, useState } from 'react';
import { Image, ImageStyle, StyleProp, ImageResizeMode } from 'react-native';
import { useAssetDownloader } from '@/contexts/DownloadAssetContext';

type OfflineImageProps = {
  source: number | { uri: string };
  resizeMode?: ImageResizeMode;
  style?: StyleProp<ImageStyle> | StyleProp<ImageStyle>[];
};

const OfflineImage: React.FC<OfflineImageProps> = ({
  source,
  resizeMode = 'contain',
  style = {},
}) => {
  const { getLocalUri } = useAssetDownloader();

  const [imageUri, setImageUri] = useState<number | { uri: string } | null>(
    null,
  );

  useEffect(() => {
    let isMounted = true;

    const getImageAsync = async () => {
      if (typeof source === 'number') {
        setImageUri(source); // Local resource via require
        return;
      }

      if (!isMounted) {
        return;
      }

      const image = await getLocalUri(source.uri);
      if (isMounted) {
        setImageUri({ uri: image });
      }
    };

    getImageAsync();

    return () => {
      isMounted = false;
    };
  }, [source]);

  return (
    <Image
      source={imageUri ?? undefined}
      resizeMode={resizeMode}
      style={style}
    />
  );
};

export default OfflineImage;
